var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "charge-amount-sum-by-currency" },
    [
      _c(
        "span",
        {
          staticStyle: {
            color: "deepskyblue",
            cursor: "pointer",
            "padding-left": "5px"
          },
          on: { click: _vm.toggle }
        },
        [
          _vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_AmountToDetail")) + " "),
          _c("i", {
            class: _vm.showPop ? "el-icon-caret-top" : "el-icon-caret-bottom"
          })
        ]
      ),
      _c("cargo-ag-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showPop,
            expression: "showPop"
          }
        ],
        staticStyle: {
          width: "330px",
          height: "230px",
          position: "absolute",
          bottom: "50px",
          right: "0"
        },
        attrs: {
          "show-side-bar": false,
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }